<div class="tab-page" *ngIf="active">
    <ng-content>
    </ng-content>
</div>
